var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCruiseControl24 = function SvgCruiseControl24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m9.813 20.071-.757.926C7.75 19.579 6.994 17.54 7 15.599a7.683 7.683 0 0 1 2.056-5.217 7.465 7.465 0 0 1 5.02-2.37 7.44 7.44 0 0 1 5.257 1.767 7.587 7.587 0 0 1 1.99 2.658A7.695 7.695 0 0 1 22 15.704a7.508 7.508 0 0 1-1.466 4.44c-.062.079-.8.915-.859.853l-.955-.926M11 13l3 3M2 2l4 4m8 2v2m6.121 1-1.414 1.414M22 16h-2M9 16H7",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m3.084 6.33 3.248-3.248a.281.281 0 0 1 .47.127l1.189 4.437a.282.282 0 0 1-.347.344L3.211 6.803a.282.282 0 0 1-.127-.473Z",
    fill: "currentColor"
  })));
};
export default SvgCruiseControl24;